var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.995 40l.721-.841c.61-.721 1.186-1.459 1.731-2.212.785-1.074 1.482-2.107 2.091-3.1.738-1.25 1.315-2.413 1.731-3.486.481-1.266.721-2.388.721-3.366 0-1.282-.312-2.46-.937-3.533-.625-1.058-1.466-1.9-2.524-2.524-1.074-.625-2.252-.938-3.534-.938s-2.46.313-3.533.938c-1.058.625-1.9 1.466-2.524 2.524-.625 1.073-.938 2.251-.938 3.533 0 .978.24 2.1.721 3.366.417 1.073.994 2.235 1.73 3.485.61.994 1.307 2.027 2.092 3.101.545.753 1.122 1.49 1.731 2.212l.721.841zm0-10.529c-.689 0-1.274-.24-1.755-.721-.48-.48-.72-1.066-.72-1.755 0-.449.111-.865.336-1.25.224-.384.525-.689.901-.913.377-.225.79-.337 1.238-.337.449 0 .866.112 1.25.337.385.224.69.529.914.913.224.385.336.801.336 1.25 0 .449-.112.862-.336 1.238-.225.377-.53.677-.914.902-.384.224-.801.336-1.25.336z",
    transform: "translate(-61 -696) translate(42 676)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location_icon.91c944c329d07e20416341e5799d1a6e.svg";
export { ForwardRef as ReactComponent };